/**
 * Intrinsic dimensions for bundled media, keyed by the source file stem.
 * Used to set explicit width/height on <img>/<video> so the browser can
 * reserve layout space (prevents CLS) before the asset downloads.
 */
const DIMS: Record<string, [number, number]> = {
  "benefit-security-v2": [1408, 912],
  "benefit-team-v2": [1408, 912],
  "business-revenue-v2": [1408, 912],
  "heart-icon-v2": [768, 1024],
  "hero-heart-v2": [1408, 816],
  "how-context-v2": [1408, 912],
  "how-document-v2": [1408, 912],
  "how-initiate-v2": [1408, 912],
  "market-growth-v2": [1408, 912],
  "mosaic-icu-v2": [1200, 912],
  "mosaic-lead-v2": [1200, 912],
  "mosaic-meds-v2": [1200, 912],
  "mosaic-team-v2": [1200, 912],
  "problem-time-v2": [1408, 912],
  "security-compliance-v2": [1408, 912],
  "security-quantum-v2": [1408, 912],
  "solution-cart-v2": [1408, 912],
  "tech-devices-v2": [1408, 912],
  "tech-ui-v2": [1408, 912],
  "train-experts-v2": [1408, 912],
  "benefit-timing-new": [1280, 720],
  "datasyte-logo": [460, 196],
  "datasyte-logo-white": [460, 179],
  "datasyteAI-logo-black": [800, 319],
  "mosaic-defib-new": [1280, 720],
  "quantum-code-video": [1280, 220],
};

const FALLBACK: [number, number] = [1400, 788];

/** Returns { width, height } props for a bundled (possibly hashed) asset URL. */
export const mediaDims = (src: string): { width: number; height: number } => {
  const file = src.split("/").pop() ?? "";
  const base = file.replace(/\.[a-z0-9]+$/i, "");
  const match =
    DIMS[base] ??
    Object.entries(DIMS).find(([stem]) => base.startsWith(stem))?.[1] ??
    FALLBACK;
  return { width: match[0], height: match[1] };
};
